<template>
  <div class="fluid">
    <b-card no-body class="mb-1 mt-3">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="danger"
          >Data Obat Masuk</b-button
        >
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text
            >Pada bagian ini, kita bisa mengedit isi table secara
            langsung</b-card-text
          >
          <!-- {{ listobat }} -->
          <div class="row mb-0" size="sm">
            <div class="col-md-8">
              Nama Siswa:
              <vue-bootstrap-typeahead
                ref="typeahead"
                class="mb-4"
                size="sm"
                v-model="query"
                :data="users"
                :serializer="(item) => item.nama"
                @hit="
                  selectedUser = $event;
                  noasrama = selectedUser.noasrama;
                  kelas = selectedUser.nokelas;
                "
                placeholder="pencarian nama"
              />
            </div>

            <div class="col-md mt-1"><br />NIS:{{ selectedUser.nis }}</div>
            <!-- {{ form.nis }},{{ selectedUser }} -->
          </div>

          <!-- {{ obat }} -->
          <!-- <b-button size="sm" @click="saveobat"><b-icon-save /></b-button> -->
          <table class="col-md mt-0">
            <tr>
              <th class="text-center">
                <!-- <b-button variant="outline-primary" style="font-size: 12px"> -->
                <b-icon-plus-square
                  size="sm"
                  style="cursor: pointer !important"
                  @click="obat.push({ kode: '', jumlah: 1 })"
                />
                <!-- </b-button> -->
              </th>
              <th>Nama Obat</th>
              <!-- <th>Nama Obat</th> -->
              <th class="text-right">JmlMasuk</th>
              <th class="text-right">Stok Saatini</th>
            </tr>
            <tbody v-for="(det, k) in obat" :key="k">
              <tr>
                <td>
                  <b-button
                    variant="outline-primary"
                    style="font-size: 12px"
                    size="sm"
                    ><b-icon-trash @click="obat.splice(k, 1)"
                  /></b-button>
                </td>
                <td>
                  <b-form-select
                    v-model="det.kode"
                    :options="listobat"
                    size="sm"
                    @input="
                      det.stok =
                        listobat.find((item) => item.value === det.kode)
                          ?.stok || 0
                    "
                  />
                </td>
                <!-- <td>{{ det.namaobat }}</td> -->
                <td>
                  <b-form-input
                    class="text-right"
                    v-model="det.jumlah"
                    size="sm"
                    type="number"
                  />
                </td>

                <td>
                  <b-form-input
                    class="text-right"
                    v-model="det.stok"
                    size="sm"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Obatmasuk",
  props: ["listobat"],
  data() {
    return {
      query: "",
      users: [],
      obat: [{ kode: "", jumlah: 1, stok: 0 }],
      selectedUser: {},
    };
  },
};
</script>

<style>
.gradient {
  background: linear-gradient(to bottom, #134a6e 33%, #66ff99 100%);
}
</style>
